import { setCustomer } from './customer';
import { getCustomerPaymentMethods } from './payment_methods';
import { clearBraintreeFailure } from './braintree_failure';
import { setComputedCart } from './computed_cart';
import { delayedClearFeedback, setFeedback } from './feedback';
import { fireLoginError, delayedClearLoginError } from './login_error';
import request from 'superagent';
import { cloneDeep } from 'lodash';
const SET_ONETIME_PAYMENT_SUCCESS = 'SET_ONETIME_PAYMENT_SUCCESS';
const SET_ONETIME_PAYMENT_SUCCESS_FALSE = 'SET_ONETIME_PAYMENT_SUCCESS_FALSE';

const initialState = false;

export default function reducer(state = cloneDeep(initialState), action) {
  switch (action.type) {
    case SET_ONETIME_PAYMENT_SUCCESS:
      return true;
    case SET_ONETIME_PAYMENT_SUCCESS_FALSE:
      return false;
    default:
      return state;
  }
}

export function fireOnetimePaymentSuccess( msg ){
	return { type: SET_ONETIME_PAYMENT_SUCCESS }
}

export function clearOnetimePaymentSuccess(){
	return { type: SET_ONETIME_PAYMENT_SUCCESS_FALSE }
}

export function placeOneTimePayment(nonce, token, finalFunction, additionalObj) {
  return (dispatch, getState) => {
    request
      .put('/svc/cart/payment/' + nonce + '/' + token)
      .send({ 'payment_amount': additionalObj.amount })
      .set({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
      .end((err, res) => {
        finalFunction();
        dispatch( getCustomerPaymentMethods() );
        if (err || res.statusCode !== 200) {
           return dispatch([
            clearOnetimePaymentSuccess(),
            setFeedback('Could not process your payment.'),
            delayedClearFeedback()
          ]);
        }
        setOneTimePurchaseGA(res, getState().store);

        return dispatch([
          setCustomer( res.body.customer ),
          setFeedback('Thanks! We\'ve received your payment.'),
          delayedClearFeedback(),
          fireOnetimePaymentSuccess(),
          clearBraintreeFailure()
        ]);
      });
  }
}

export function placeNonClubOneTimePayment(braintreeObj, failFunction, additionalObj){
   return (dispatch, getState) => {
    dispatch(clearOnetimePaymentSuccess())
    request
      .put('/svc/nonclub/payment/' + braintreeObj.nonce )
      .send({
        'payment_amount': additionalObj.amount,
        'details': Object.assign( braintreeObj.details, {type: braintreeObj.type}),
        'sap_account_number': additionalObj.sap_account_number
      })
      .set({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
      .end((err, res) => {
        failFunction();
        if (err || res.statusCode !== 200){
          failFunction();
          return dispatch([
            setFeedback(JSON.parse(res.text).msg),
            delayedClearFeedback(),
            clearOnetimePaymentSuccess()
          ]);
        }

        let customer = getState().customer;
        customer.balance -= res.body.payment_amount;

        return dispatch([
          setCustomer(customer),
          fireOnetimePaymentSuccess(),
          clearBraintreeFailure()
        ]);
      });
  }
}

export function getNonClubAccountBalance(sap_account_number){
   return (dispatch, getState) => {
    request
      .get('/svc/nonclub/' + sap_account_number)
      .set({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
      .end((err, res) => {
        if (err || res.statusCode !== 200){
          let sError = 'The information you entered did not match any account in our files.';
          return dispatch([
            fireLoginError(sError),
            delayedClearLoginError()
          ]);
        } else return dispatch(setCustomer(res.body));
      });
  }
}

function setOneTimePurchaseGA(res, store) {
  let payment_id = res.body.payment_history_id,
      payment_amount = res.body.payment_amount;
  window.dataLayer.push({
      'ecommerce': {
          'purchase': {
              'actionField': {
                  'id': "payment-" + store.tla.toUpperCase() + payment_id,
                  'revenue': payment_amount.toString(),
                  'tax': '0',
                  'shipping': '0',
                  'coupon': ''
              },
              'products': [
                {
                  'name' : 'One-time Payment',
                  'quantity': '1'
                }
              ]
          }
      }
  });
}



// WEBPACK FOOTER //
// ./src/modules/onetime_payment_success.js